module.exports = __webpack_public_path__ + "img/icon_map_16.f43e78f9.svg";